module.exports = __webpack_public_path__ + "static/media/icon-6.ff06ff14.svg";